/**
 * Layout Component
 *
 * Main layout wrapper for all pages.
 * Receives Prismic data for Header and Footer.
 */

import React from "react";

import Header from "../Header";
import Footer from "../Footer";
import SkipToContent from "../SkipToContent";

const Layout = ({ topMenu, footerData, children, slug }) => {
  return (
    <>
      <SkipToContent />
      <Header topMenu={topMenu} />
      <main id="main" data-page={slug}>{children}</main>
      <Footer footerData={footerData} />
    </>
  );
};

export default Layout;
